export default __webpack_public_path__ + "static/media/installationsgeraete.039e9578.webp";